// Which Call Sheets this device has finished, and when (CLAUDE.md: Call Sheet,
// as a pool game, tracks what a player has already seen).
//
// **Kept apart from the saved games, and never pruned.** The saved games
// (progress.ts) keep the latest sixty boards; this keeps every finished puzzle's
// number and the time it was finished, which is what serving "the next one not
// played" and, once the pool is used up, going back to "the one finished most
// recently" both need. A number and a timestamp each, so it stays small however long somebody
// plays.
//
// Nothing here is a TMDB copy, and storage that is not there is not an error:
// in a private window the pool simply starts from the top each visit.
const KEY = 'cinemore-call-sheet-played';

type Store = Record<string, number>;

function read(): Store {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(KEY) ?? 'null');
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed as Store : {};
  } catch {
    return {};
  }
}

// The time of the first finish. A replay is not marked (CallSheetGame.tsx), so
// "the most recent finished" is always a real first play. Stats keep their own
// record; this is only for choosing what Play opens.
export function markPlayed(number: number): void {
  const store = read();
  if (store[String(number)]) return;
  store[String(number)] = Date.now();
  try { localStorage.setItem(KEY, JSON.stringify(store)); } catch { /* blocked or full */ }
}

export function playedNumbers(): number[] {
  return Object.keys(read()).map(Number).filter((n) => Number.isInteger(n) && n > 0);
}

/** The puzzle finished most recently: what Play opens once every released one is finished. */
export function latestPlayed(): number | null {
  const entries = Object.entries(read()).sort((a, b) => b[1] - a[1]);
  return entries.length ? Number(entries[0]![0]) : null;
}
